// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  position: relative;
  display: inline-flex;
  font-weight: 400;
}

.s1cf-trigger {
  border: 1px solid #d3d9e2;
  background: #fff;
  color: #7a8290;
  border-radius: 4px;
  width: 24px;
  height: 22px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 11px;
  line-height: 1;
}

.s1cf-trigger:hover {
  background: #eef1f6;
  color: #3b4252;
}

.s1cf-trigger.active {
  background: #e9f2ff;
  border-color: #bcd6fb;
  color: #2f6fed;
}

.s1cf-pop {
  position: fixed;
  z-index: 2000;
  width: 340px;
  max-width: calc(100vw - 16px);
  background: #fff;
  border: 1px solid #d3d9e2;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.16);
  text-align: left;
  color: #333;
  cursor: default;
}

.s1cf-head {
  padding: 8px 12px;
  font-size: 13px;
  font-weight: 600;
  color: #3b4252;
  background: #f5f7fa;
  border-bottom: 1px solid #eee;
  border-radius: 7px 7px 0 0;
}

.s1cf-sort {
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #eee;
  overflow: hidden;
}

.s1cf-sort:first-child {
  border-top-left-radius: 7px;
  border-top-right-radius: 7px;
}

.s1cf-sort:last-child {
  border-bottom: none;
  border-bottom-left-radius: 7px;
  border-bottom-right-radius: 7px;
}

.s1cf-sort button {
  display: flex;
  align-items: center;
  gap: 8px;
  border: none;
  background: #fff;
  padding: 9px 12px;
  text-align: left;
  cursor: pointer;
  color: #444;
  font-size: 13px;
}

.s1cf-sort button:hover {
  background: #f3f6fb;
}

.s1cf-sort button.active {
  color: #2f6fed;
  font-weight: 500;
}

.s1cf-sort button i {
  width: 12px;
  color: #8a93a0;
}

.s1cf-body {
  padding: 10px 12px;
}

.s1cf-list {
  max-height: 180px;
  overflow: auto;
  border: 1px solid #eef1f5;
  border-radius: 5px;
  padding: 4px 0;
}

.s1cf-opt {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 5px 12px;
  margin: 0;
  cursor: pointer;
  font-size: 13px;
  font-weight: 400;
}

.s1cf-opt:hover {
  background: #f3f6fb;
}

.s1cf-opt.s1cf-all {
  border-bottom: 1px solid #eef1f5;
  font-weight: 600;
}

.s1cf-foot {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  padding: 10px 12px;
  border-top: 1px solid #eee;
}

.s1cf-foot .btn {
  flex: 1;
}`, "",{"version":3,"sources":["webpack://./src/app/s1/s1-column-filter/s1-column-filter.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,oBAAA;EACA,gBAAA;AACF;;AAEA;EACE,yBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;AACF;;AACA;EAAsB,mBAAA;EAAqB,cAAA;AAI3C;;AAHA;EAAuB,mBAAA;EAAqB,qBAAA;EAAuB,cAAA;AASnE;;AAPA;EACE,eAAA;EACA,aAAA;EACA,YAAA;EACA,6BAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,0CAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;AAUF;;AANA;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,6BAAA;EACA,0BAAA;AASF;;AAJA;EACE,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,gBAAA;AAOF;;AALA;EAAyB,2BAAA;EAA6B,4BAAA;AAUtD;;AARA;EACE,mBAAA;EACA,8BAAA;EACA,+BAAA;AAWF;;AATA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;AAYF;;AAVA;EAA0B,mBAAA;AAc1B;;AAbA;EAA2B,cAAA;EAAgB,gBAAA;AAkB3C;;AAjBA;EAAsB,WAAA;EAAa,cAAA;AAsBnC;;AApBA;EAAa,kBAAA;AAwBb;;AAtBA;EACE,iBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;AAyBF;;AAvBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,SAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;AA0BF;;AAxBA;EAAkB,mBAAA;AA4BlB;;AA3BA;EAAqB,gCAAA;EAAkC,gBAAA;AAgCvD;;AA9BA;EACE,aAAA;EACA,8BAAA;EACA,QAAA;EACA,kBAAA;EACA,0BAAA;AAiCF;;AA/BA;EAAkB,OAAA;AAmClB","sourcesContent":[":host {\n  position: relative;\n  display: inline-flex;\n  font-weight: 400;\n}\n\n.s1cf-trigger {\n  border: 1px solid #d3d9e2;\n  background: #fff;\n  color: #7a8290;\n  border-radius: 4px;\n  width: 24px;\n  height: 22px;\n  padding: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-size: 11px;\n  line-height: 1;\n}\n.s1cf-trigger:hover { background: #eef1f6; color: #3b4252; }\n.s1cf-trigger.active { background: #e9f2ff; border-color: #bcd6fb; color: #2f6fed; }\n\n.s1cf-pop {\n  position: fixed;\n  z-index: 2000;\n  width: 340px;\n  max-width: calc(100vw - 16px);\n  background: #fff;\n  border: 1px solid #d3d9e2;\n  border-radius: 8px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, .16);\n  text-align: left;\n  color: #333;\n  cursor: default;\n}\n\n// intestazione: nome della colonna a cui si riferisce il popover\n.s1cf-head {\n  padding: 8px 12px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #3b4252;\n  background: #f5f7fa;\n  border-bottom: 1px solid #eee;\n  border-radius: 7px 7px 0 0;\n}\n\n// i pulsanti hanno sfondo proprio: arrotondo la sezione (raggio del popover - bordo) per non coprire gli angoli\n// quando è la prima o l'ultima. Niente overflow hidden sul popover: le tendine ng-select dei filtri custom si aprono al suo interno.\n.s1cf-sort {\n  display: flex;\n  flex-direction: column;\n  border-bottom: 1px solid #eee;\n  overflow: hidden;\n}\n.s1cf-sort:first-child { border-top-left-radius: 7px; border-top-right-radius: 7px; }\n// popover di solo ordinamento: la sezione è anche l'ultima\n.s1cf-sort:last-child {\n  border-bottom: none;\n  border-bottom-left-radius: 7px;\n  border-bottom-right-radius: 7px;\n}\n.s1cf-sort button {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  border: none;\n  background: #fff;\n  padding: 9px 12px;\n  text-align: left;\n  cursor: pointer;\n  color: #444;\n  font-size: 13px;\n}\n.s1cf-sort button:hover { background: #f3f6fb; }\n.s1cf-sort button.active { color: #2f6fed; font-weight: 500; }\n.s1cf-sort button i { width: 12px; color: #8a93a0; }\n\n.s1cf-body { padding: 10px 12px; }\n\n.s1cf-list {\n  max-height: 180px;\n  overflow: auto;\n  border: 1px solid #eef1f5;\n  border-radius: 5px;\n  padding: 4px 0;\n}\n.s1cf-opt {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 5px 12px;\n  margin: 0;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 400;\n}\n.s1cf-opt:hover { background: #f3f6fb; }\n.s1cf-opt.s1cf-all { border-bottom: 1px solid #eef1f5; font-weight: 600; }\n\n.s1cf-foot {\n  display: flex;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 10px 12px;\n  border-top: 1px solid #eee;\n}\n.s1cf-foot .btn { flex: 1; }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
